export default function Footer() {
    return <div className="py-4 bg-primary text-center text-white">
        &copy; All credits are taken by Prakash.Dhanraj
    </div>
}